import React from 'react';
import PropTypes from 'prop-types';
import ReactGA from "react-ga4";

//Rendering Form for a quote
const ShowPredefinedQuestionsQuotes = ({ setFormData, setShowFormQuote, handleSetMessage, handleFormSubmit, formData, productCookie ,numberCookie ,setIsInputDisabled,setIsMenuDisabled,setMessages}) => {
  const predefinedQuestions = [
    "Phone number",
    "Company name",
    "Product Name",
    "Quantity",
    "Unit of Measurement",
    "Email Address"
  ];

  const handleCancel = () => {
    ReactGA.event({
        category: 'Navigation',
        action: 'Cancelled Form',
    });
    setShowFormQuote(false);
    setFormData({});
    setMessages((prevMessages) => {
        // Check if the last message contains the specified text
        if (prevMessages.length > 0 && prevMessages[prevMessages.length - 1].text === "Please let me know if you need more help.") {
            return prevMessages.slice(0, -1);
        }
        return prevMessages;
    });
    
    handleSetMessage("Please let me know if you need more help.", "system");
    setIsInputDisabled(false);
    setIsMenuDisabled(false);
  };

  React.useEffect(() => {
    if (productCookie && !formData["Product Name"]) {
      setFormData((prevData) => ({
        ...prevData,
        "Product Name": productCookie,
      }));
    }
  }, [productCookie, formData, setFormData]);

  React.useEffect(() => {
    if (numberCookie && !formData["Phone number"]) {
      setFormData((prevData) => ({
        ...prevData,
        "Phone number": numberCookie,
      }));
    }
  }, [numberCookie, formData, setFormData]);

  return (
    <div className="message system-message">
      <p className="system-call">
        Please fill out the following details for your Quote:
      </p>
      <form onSubmit={(e) => handleFormSubmit(e)} className="form-control">
        {predefinedQuestions.map((question, index) => (
          <div key={index} className="form-group">
            <input
              required
              type="text"
              id={`question-${index}`}
              className="form-in"
              placeholder={question}
              value={formData[question] || ""}
              onChange={(e) =>
                setFormData((prevData) => ({
                  ...prevData,
                  [question]: e.target.value,
                }))
              }
            />
          </div>
        ))}
        <div className="button-group">
          <button type="button" className="btn btn-full btn-secondary" onClick={handleCancel}>
              Cancel
            </button>
          <button type="submit" className="btn btn-full btn-primary">
            Submit
          </button>
        </div>
      </form>
    </div>
  );
};

ShowPredefinedQuestionsQuotes.propTypes = {
  setFormData: PropTypes.func.isRequired,
  setShowFormQuote: PropTypes.func.isRequired,
  handleSetMessage: PropTypes.func.isRequired,
  handleFormSubmit: PropTypes.func.isRequired,
  formData: PropTypes.object,
  productCookie: PropTypes.string,
};

ShowPredefinedQuestionsQuotes.defaultProps = {
  formData: {},
};

export default ShowPredefinedQuestionsQuotes;
